import React from 'react';
import { CurveWrapper, Arc } from './styled';

const DoubleCurveSection: React.FC = () => {
  return (
    <CurveWrapper>
      {/* Back arc (bottom, lighter) */}
      <Arc color="rgba(255, 180, 93, 0.45)" topOffset="90px"  style={{ zIndex: 1 }}>
        <svg viewBox="0 0 1440 320" preserveAspectRatio="none">
  <path d="M0,210 C480,30 960,30 1440,210 L1440,320 L0,320 Z" />
</svg>
        </Arc>

      {/* Front arc (top, darker) */}
      <Arc color="#F7931E">
        <svg viewBox="0 0 1440 320" preserveAspectRatio="none">
  <path d="M0,210 C480,30 960,30 1440,210 L1440,320 L0,320 Z" />
</svg>
      </Arc>
    </CurveWrapper>
  );
};

export default DoubleCurveSection;
